import React, { useState } from 'react';
import { motion } from 'framer-motion';

export default function LandingHero() {
    const [menuOpen, setMenuOpen] = useState(false);


    return (
        <>
            <style>{`
                #home-hero-bg {
                  background-image: url('https://lukos.com.br/wp-content/uploads/2025/01/S-TEXTO-1.png');
                  background-size: cover;
                  background-position: center top;
                  background-repeat: no-repeat;
                }

                @media (max-width: 767px) {
                  #home-hero-bg {
                    background-image: url("https://lukos.com.br/wp-content/uploads/2025/01/Banner-mobile.png");
                    background-size: contain;
                    background-position: center top;
                  }
                }
            `}</style>

            <section id="home-hero-bg" className="flex flex-col items-center text-sm bg-white pb-40 relative min-h-[804px] justify-center">


                <div
                    className={`fixed inset-0 z-[100] bg-white/95 text-slate-900 backdrop-blur-xl flex flex-col items-center justify-center text-lg gap-8 md:hidden transition-transform duration-300 ${menuOpen ? 'translate-x-0' : '-translate-x-full'
                        }`}
                >
                    <a href="/" className="font-bold">Home</a>
                    <a href="/products" className="font-bold">Produtos</a>
                    <a href="/lukos" className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600">Lukos</a>
                    <a href="/pricing" className="font-bold">Sobre</a>
                    <button
                        onClick={() => setMenuOpen(false)}
                        className="active:ring-3 a ctive:ring-slate-900 aspect-square size-10 p-1 items-center justify-center bg-slate-100 hover:bg-slate-200 transition text-slate-900 rounded-md flex"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-icon lucide-x">
                            <path d="M18 6 6 18" />
                            <path d="m6 6 12 12" />
                        </svg>
                    </button>
                </div>

                <main className="container mx-auto px-6 md:px-16 lg:px-24 xl:px-32 flex flex-col items-start w-full pt-48 relative z-10 ">

                    <motion.h1
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-left text-4xl md:text-5xl lg:text-[52px] font-extrabold max-w-2xl text-slate-800 uppercase leading-[1.1] tracking-tight mt-28"
                    >
                        Potencialize a gestão <br /> do seu posto de <br /> combustível com a <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 drop-shadow-sm">
                           LUKOS
                        </span>
                    </motion.h1>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.3 }}
                        className="mt-10"
                    >
                        <p className="text-left text-lg md:text-xl text-slate-600 font-medium max-w-xl leading-relaxed">
                            Tenha total controle do seu negócio em tempo real, elimine dores de cabeça com o fisco e recupere o tempo livre para focar no que importa: <b>lucrar</b>.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                        className="flex items-center gap-4 mt-12"
                    >
                        <button className="flex items-center justify-center bg-purple-600 hover:bg-purple-700 text-white font-black rounded-2xl px-12 h-16 min-w-[280px] text-xs uppercase tracking-[0.2em] transition-all active:scale-95 shadow-[0_25px_50px_-12px_rgba(147,51,234,0.3)]">
                            Falar com Especialista
                        </button>


                    </motion.div>

                </main>

                {/* Scroll Down Button */}

            </section>
        </>
    );
}
